import {createUseStyles} from "react-jss"
import Card from "../components/Card"
import FullScreenLoadingIndicator from "../components/FullScreenLoadingIndicator"
import {useTranslation} from "react-i18next"
import {apiConfig} from "../apiConfig"
import BackButton from "../components/BackButton"
import useExternalScript, {ExternalScriptState} from "../hooks/useExternalScript"
import {useNavigate, useSearchParams} from "react-router-dom";
import {useAppSelector} from "../redux/hooks";
import {isDateValid} from "../util/date";
import InfoCard from "../components/InfoCard";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faUpload} from "@fortawesome/free-solid-svg-icons";

declare global {
  // We register a global callback function that is called from the WASM code
  // using JSInterop, as we can't register a callback function directly.
  interface Window {
    OnEmployerInitiatedPayoutProcessed: () => void;
  }
}

const EmployerInitiatedPayoutProcessor = () => {
  const styles = useStyles()
  const {t} = useTranslation('employerInitiatedPayout');
  const wasmScriptState = useExternalScript('_framework/blazor.webassembly.js?version=' + apiConfig.blazorAppVersion);
  const navigate = useNavigate()

  window.OnEmployerInitiatedPayoutProcessed = () => {
    navigate('/payroll?refresh=true')
  }

  return (
    <>
      <BackButton/>
      <Card className={styles.card}>
        <h2>
          {t('employerInitiatedPayout')}
        </h2>
      </Card>
      <Card>
        {wasmScriptState == ExternalScriptState.ready &&
            <employer-initiated-payout-component api-base-url={apiConfig.baseUrl}
                                    auth-token={localStorage.getItem('authToken')}/>
        }
        <FullScreenLoadingIndicator visible={wasmScriptState === ExternalScriptState.loading}/>
      </Card>
    </>
  )
}

export default EmployerInitiatedPayoutProcessor

const useStyles = createUseStyles({
  card: {
    marginBottom: 20
  },
  infoCardContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    alignItems: 'center'
  },
  button: {
    alignSelf: 'flex-end'
  }
})
